module.exports = __webpack_public_path__ + "img/late.aa2515a8.webp";